import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, resolveForwardRef } from '@angular/core';
import { DataService } from '../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HeaderService } from '../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-headers',
    templateUrl: './headers.component.html',
    styleUrls: ['./headers.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeadersComponent implements OnInit {
    @ViewChild('container', { read: ElementRef }) container: ElementRef;

    private subscription: Subscription[] = [];
    public data: string = '';
    public TopBarStyle = '';
    public tempValue;
    public showCode = '';

    headerSettings = {};
    dropdownList = [];
    selectedItemsRight = [];
    selectedItemsLeft = [];
    dropdownSettings = {};
    actionBarEnabled : Boolean = false;
    headerToolsEnabled : Boolean = false;
    topBarPosition : string = 'left';
    css_text : string = '';

    headerToolsList = [];
    selectedHeaderTools = [];

    codeElement: any;


    constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService : HeaderService, private _titleService : Title) {
		_titleService.setTitle('Headers');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
        this.subscription.push(_headerService.headerSettings.subscribe(data=>{
            this.headerSettings = data;
        }));
        this.subscription.push(_headerService.dropdownList.subscribe(data=>{
            this.dropdownList = data;
        }));
        this.subscription.push(_headerService.dropdownSettings.subscribe(data=>{
            this.dropdownSettings = data;
        }));
        this.subscription.push(_dataService.headerToolsList.subscribe(data=>{
            this.headerToolsList = data;
        }))

        this.subscription.push(this._dataService.actionBarEnabled.subscribe(data=>{
            this.actionBarEnabled = data;
        }));
        this.subscription.push(this._dataService.headerToolsEnabled.subscribe(data=>{
            this.headerToolsEnabled = data;
        }));
        if (localStorage.headerSettings) {
            let headerSettings = JSON.parse(localStorage.headerSettings);
            this.loadSettings(headerSettings);
            this._dataService.toggleActionBar(headerSettings.actionBarEnabled);
            this._dataService.toggleHeaderTools(headerSettings.headerToolsEnabled);
          }
    }

    ngOnInit() {
        this.subscription.push(this._dataService.GetCode().subscribe(code => {
            this.data = code;
            this.cdRef.detectChanges();
        }));

        this.topBarPosition = 'left';

        if(!localStorage.headerSettings){
            this.selectedItemsLeft = [
                { item_class: 'contact-box', item_text: 'Contact Details' }
            ];
            this.selectedItemsRight = [
                { item_class: 'social-box', item_text: 'Social Icons' }
            ];
        }

        this._dataService.SetActionBarRightList(this.selectedItemsRight);
        this._dataService.SetActionBarLeftList(this.selectedItemsLeft);

        if(!localStorage.headerSettings){
            this.selectedHeaderTools = [
                { item_class: 'keyword-search', item_text: 'Keyword Search' }
            ];
        }

        this._dataService.SetHeaderToolsList(this.selectedHeaderTools);

        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);

    }

    onItemSelectRight(item: any) {
        console.log(this.selectedItemsRight);
        this._dataService.SetActionBarRightList(this.selectedItemsRight);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }
    onItemDeSelectRight(item: any){
        const index: number = this.selectedItemsRight.indexOf(item.item_class);
        if (index !== -1) {
            this.selectedItemsRight.splice(index, 1);
        }
        this._dataService.SetActionBarRightList(this.selectedItemsRight);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }

    onItemSelectLeft(item: any) {
        this._dataService.SetActionBarLeftList(this.selectedItemsLeft);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }
    onItemDeSelectLeft(item: any){
        const index: number = this.selectedItemsLeft.indexOf(item.item_class);
        if (index !== -1) {
            this.selectedItemsLeft.splice(index, 1);
        }
        this._dataService.SetActionBarLeftList(this.selectedItemsLeft);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }

    onHeaderToolSelect(item: any) {
        this._dataService.SetHeaderToolsList(this.selectedHeaderTools);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }
    onHeaderToolDeSelect(item: any){
        const index: number = this.headerToolsList.indexOf(item.item_class);
        if (index !== -1) {
            this.selectedHeaderTools.splice(index, 1);
        }
        this._dataService.SetHeaderToolsList(this.selectedHeaderTools);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }


    onSelectAll(items: any) {
        console.log(items);
    }

    ngOnDestroy(): void {
        this.subscription.map(subscription => {
            subscription.unsubscribe();
        })
    }

    // SetCurrentActionBarLeftTool(value: string) {
    //     this.cdRef.detectChanges();
    //     this._dataService.SetCode(this.container.nativeElement.innerHTML);
    // }

    // SetCurrentActionBarRightTool(value: string) {
    //     this.cdRef.detectChanges();
    //     this._dataService.SetCode(this.container.nativeElement.innerHTML);
    // }

    SetCurrentTopBarStyle(value: string) {
        if(value){
            this.TopBarStyle = value;
            this.cdRef.detectChanges();
            this._dataService.SetCode(this.container.nativeElement.innerHTML);
        }else{
            this.TopBarStyle = value;
            this.cdRef.detectChanges();
            this._dataService.SetCode(this.container.nativeElement.innerHTML);
        }

    }

	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'headers') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('headers');
		}
	}

    toggleActionBar(value : any){
        this._dataService.toggleActionBar(value);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }
    toggleHeaderTools(value : any){
        this._dataService.toggleHeaderTools(value);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }
    toggleTopBarPosition(value : any){
        this.topBarPosition = value;
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.container.nativeElement.innerHTML);
    }

    setCssText(data){
        this.css_text = data;
        console.log(this.css_text);
        this.cdRef.detectChanges();
        this._dataService.SetCode(this.css_text);
    }

    Save(){
        let headerSettings = {
            TopBarStyle : this.TopBarStyle,
            dropdownList : this.dropdownList,
            selectedItemsRight : this.selectedItemsRight,
            selectedItemsLeft : this.selectedItemsLeft,
            dropdownSettings : this.dropdownSettings,
            actionBarEnabled : this.actionBarEnabled,
            headerToolsEnabled : this.headerToolsEnabled,
            topBarPosition : this.topBarPosition,
            headerToolsList : this.headerToolsList,
            selectedHeaderTools : this.selectedHeaderTools
        }
        localStorage.setItem('headerSettings', JSON.stringify(headerSettings));
        this._headerService.setHeaderSettings(headerSettings);
    }

    loadSettings(headerSettings){
        this.TopBarStyle            = headerSettings.TopBarStyle,
        this.dropdownList           = headerSettings.dropdownList,
        this.selectedItemsRight     = headerSettings.selectedItemsRight,
        this.selectedItemsLeft      = headerSettings.selectedItemsLeft,
        this.dropdownSettings       = headerSettings.dropdownSettings,
        this.actionBarEnabled       = headerSettings.actionBarEnabled,
        this.headerToolsEnabled     = headerSettings.headerToolsEnabled,
        this.topBarPosition         = headerSettings.topBarPosition,
        this.headerToolsList        = headerSettings.headerToolsList,
        this.selectedHeaderTools    = headerSettings.selectedHeaderTools
        this._dataService.toggleActionBar( this.actionBarEnabled);
        this._dataService.toggleHeaderTools(this.headerToolsEnabled);
        console.log(headerSettings);
    }

    loadDefaults(){
        let headerSettings = this._headerService.loadDefaults();
        this.TopBarStyle            = headerSettings.TopBarStyle,
        this.dropdownList           = headerSettings.dropdownList,
        this.selectedItemsRight     = headerSettings.selectedItemsRight,
        this.selectedItemsLeft      = headerSettings.selectedItemsLeft,
        this.dropdownSettings       = headerSettings.dropdownSettings,
        this.actionBarEnabled       = headerSettings.actionBarEnabled,
        this.headerToolsEnabled     = headerSettings.headerToolsEnabled,
        this.topBarPosition         = headerSettings.topBarPosition,
        this.headerToolsList        = headerSettings.headerToolsList,
        this.selectedHeaderTools    = headerSettings.selectedHeaderTools
        this._dataService.toggleActionBar( this.actionBarEnabled);
        this._dataService.toggleHeaderTools(this.headerToolsEnabled);
    }

}


// WEBPACK FOOTER //
// ./src/app/headers/headers.component.ts